<div class="c11n-text margin-top"  *ngIf="footNoteCaasContent">
  <div>
    <div role="heading" aria-level="1">
      <h2 class="c11n-text-lg-headline">{{ footNoteCaasContent.footnoteHeader }}</h2>
    </div>
    <span id="pfrmcDisclaimer" *ngIf="performanceTable||literatureTable" [innerHTML]="footNoteCaasContent.performance.html"></span>
    <br>
  </div>
  <div>
    <ng-container *ngIf="performanceTable">
      <span id="pfrmcPrcDisclaimer" [innerHTML]="footNoteCaasContent.performancePrice.html"></span>
      <br>
    </ng-container>
    <ng-container *ngIf="performanceTable">
      <p class="italic-font"><span id="etfPrcDisclaimer" [innerHTML]="marketPriceDisclosure"></span></p>
      <br>
    </ng-container>
    <ng-container *ngIf="((performanceTable || literatureTable) && !cashEquivalent)">
      <span id="prcLitrDiscalimer1" [innerHTML]="footNoteCaasContent.collectiveTrust.html"></span>
      <br>
    </ng-container>
    <ng-container *ngIf="((performanceTable || literatureTable) && ((cashEquivalent || noFilterSelectedForAsset) && index))">
      <span id="prcLitrDiscalimer2" [innerHTML]="footNoteCaasContent.moneyMarket.html"></span>
      <br>
    </ng-container>
    <ng-container *ngIf="performanceTable || literatureTable">
      <span id="prcLitrDiscalimer3" [innerHTML]="footNoteCaasContent.perfPriceLit.html"></span>
    </ng-container>
  </div>
</div>
